import { Activity } from './Handbooks/Activity';

/**
 * Тип индустрии / сферы / области<para/>
 * Industry / subindustry type
 */
export class Industry {
    /**
     * Первичный ключ<para/>
     * Primary key
     */
    Id: number = 0;
    /**
     * Является ли эта индустрия корневой т.е. сферой?<para/>
     * Is this industry root e.g. sphere?
     */
    IsRootSphere: boolean = false;
    /**
     * Наименование<para/>
     * Name
     */
    Name: string = '';
    /**
     * Наименование на казахском языке<para/>
     * Name in kazakh
     */
    NameKz: string = '';
    /**
     * Наименование на английском языке<para/>
     * Name in english
     */
    NameEn: string = '';
    /**
     * Идентификатор типа активной области<para/>
     * Activity type identifier
     */
    ActivityId: number = 0;
    /**
     * Тип активной области<para/>
     * Activity type
     */
    Activity: Activity = null;
    //#region Parent and Children Industries
    /**
     * Идентификатор родительской индустрии<para/>
     * Parent industry's identifier
     */
    ParentId: number = 0;
    /**
     * Родительская индустрия<para/>
     * Parent industry
     */
    Parent: Industry = null;
    /**
     * Дочерние индустрии<para/>
     * Children industries
     */
    Children: Array<Industry> = null;
    //#endregion
}